var React = require('react');

function IconCRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.627 6.745a.969.969 0 0 0 0 1.33l3.053 3.24a1 1 0 0 1 0 1.37l-3.053 3.24a.969.969 0 0 0 1.409 1.33l4.315-4.568a1 1 0 0 0 0-1.374l-4.315-4.568a.969.969 0 0 0-1.409 0zm-5 0a.969.969 0 0 0 0 1.33l3.053 3.24a1 1 0 0 1 0 1.37l-3.053 3.24a.969.969 0 0 0 1.409 1.33l4.315-4.568a1 1 0 0 0 0-1.374L8.036 6.745a.969.969 0 0 0-1.409 0z","fill":"#00B2FF"}));
}

IconCRight.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IconCRight;

IconCRight.default = IconCRight;
